export default {"src":"/_next/static/media/download.8e16fbc1.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};